// PFS-425 Shadow-DOM-Inheritance-Reset. Canonical Source.
//
// Light-DOM-Themes (WP body { font-size: var(--wp--preset--font-size--large);
// line-height: 1.4 } und mednet-app-Body) vererben via inherit durch jeden
// Shadow-Boundary — Cut-App-WC-Inputs/Buttons/Cards werden im em-Bezug zu
// gross. feedback_env_agnostic_webcomponents.
//
// Zwei Klassen:
//   (a) defense-in-depth Properties (size/weight/line-height/letter-spacing/
//       text-*) hart gepinnt — Override ist Anti-Pattern.
//   (b) Brand-Properties (font-family, color) als CSS-Custom-Properties
//       themeable. font-family: --pfs-base-font-family (cross-WC-Reset-Token);
//       color: --pfs-color-on-surface (PFS-732-Kanon, kein rohes Hex mehr).
//
// `display` setzt der Reset bewusst NICHT — das ist WC-spezifisch (block /
// inline-block / flex / inline). Konsumenten setzen es in ihrem eigenen
// :host-Block; weil dieser textuell nach dem Reset kommt, gewinnt er.
//
// Pattern (in jedem WC):
//   const STYLES = `
//     ${SHADOW_RESET_CSS}
//     :host { display: ...; <WC-spezifisches Sizing>; }
//     ...
//   `;

export const SHADOW_RESET_CSS = `
:host {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  text-transform: none;
  box-sizing: border-box;
  font-family: var(--pfs-base-font-family,
    -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif);
  color: var(--pfs-color-on-surface);
}
:host *, :host *::before, :host *::after { box-sizing: border-box; }
/* Das hidden-Attribut EINMAL fuer alle WCs respektieren: das WC-eigene
   :host{display:...} ueberschreibt sonst die UA-Regel [hidden]{display:none}
   (hoehere Spezifitaet). :host([hidden]) gewinnt per Spezifitaet gegen :host,
   egal in welcher Reihenfolge — so muss es niemand mehr pro WC selbst loesen. */
:host([hidden]) { display: none !important; }
`;
